import { tx, txt, useContent } from "@/content/ContentContext";
import { BarChart3, CalendarRange, Crown, Download, GitBranch } from "lucide-react";

const POINTS = () => ([
  [CalendarRange, tx("landing.daily_weekly_monthly"), tx("landing.today_last_7_days_this")],
  [GitBranch, tx("landing.every_branch_or_one"), tx("landing.compare_branches_managers_only_see")],
  [BarChart3, tx("landing.net_revenue_at_a_glance"), tx("landing.gross_sales_discounts_returns_net")],
  [Download, tx("landing.export_to_csv"), tx("landing.send_the_table_to_your")],
]);

export function ReportsSection() {
  useContent();
  return (
    <section id="reports" className="scroll-mt-20 bg-white" data-testid="landing-reports">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-8">
        <div className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-slate-950" data-testid="landing-reports-badge"><Crown className="h-3.5 w-3.5" /> {txt("landing.premium")}</div>
        <div className="mt-5 grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{txt("landing.sales_and_profit_reports_that")}</h2>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600">Every POS, offline and online-store sale rolls into one report, in your local time and currency, with a Profit &amp; Loss view of cost of goods, gross profit and margin. Included in Growth, Business and Enterprise, or add Reports to any plan.</p>
          </div>
          <div className="grid gap-5 sm:grid-cols-2">
            {POINTS().map(([Icon, t, d]) => (
              <div key={t} className="rounded-2xl border border-slate-200 p-5">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-slate-900 text-amber-400"><Icon className="h-5 w-5" /></span>
                <div className="mt-3 font-display font-bold text-slate-900">{t}</div>
                <p className="mt-1 text-sm text-slate-600">{d}</p>
              </div>))}
          </div>
        </div>
      </div>
    </section>
  );
}
